"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageVisibilityWriter = void 0;
var hidden_imageVisibility_1 = require("../imageVisibility/hidden.imageVisibility");
function writeHiddenImageVisibility(imageVisibility) {
    var state = imageVisibility.state;
    var hidden = state.hidden;
    return {
        id: state.id,
        tag: 'hidden',
        hidden: hidden
    };
}
var ImageVisibilityWriter = /** @class */ (function () {
    function ImageVisibilityWriter() {
    }
    ImageVisibilityWriter.write = function (imageVisibility) {
        if (hidden_imageVisibility_1.CollectionModelHiddenImageVisibility.isHidden(imageVisibility)) {
            return writeHiddenImageVisibility(imageVisibility);
        }
        throw new Error("Unexpected drawable: ".concat(imageVisibility.id, ":").concat(imageVisibility.state.tag));
    };
    return ImageVisibilityWriter;
}());
exports.ImageVisibilityWriter = ImageVisibilityWriter;
//# sourceMappingURL=collection.model.write.imageVisibility.js.map